// components/ui/skeleton.tsx

import React from "react";

import { cn } from "../../lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn("skeleton-shimmer BookEZ_card_radius", className)}
      {...props}
    />
  );
}
